/**
 * Created by Mark on 20/04/2017.
 */
export default class CDNAudio{
    getAudioBaseUrl() {
        if (window.location.hostname.indexOf('localhost') >-1) {
            //Change to localhost image repo
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('beta') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('alpha') >-1) {
            return "https://beta.assets.languagenut.com/";
        }  else if (window.location.hostname.indexOf('gamma') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else {
            return "https://storage.languagenut.com/";
        }
    }

    constructor(src){
        this.src = src;
        this.cdn = this.getAudioBaseUrl() ;
        this.audio = new Audio(this.cdn+this.src);
    }

    play(){
        this.audio.play();
    }
}